// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { clockExclamation16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-clock-exclamation': IconClockExclamation;
    }
}

/**
 * The icon component for the 'clockExclamation' icon
 */
export class IconClockExclamation extends IconSvg {
    public constructor() {
        super(clockExclamation16X16);
    }
}

registerIconSvg('icon-clock-exclamation', IconClockExclamation);
export const iconClockExclamationTag = 'nimble-icon-clock-exclamation';
